export default __webpack_public_path__ + "static/media/bottom-left-trello.47238298.svg";